<template>
  <div class="root_page">
    <div class="table_wrapper">
      <div class="ctrl-wrapper">
        <div class="search_wrapper">
          <div class="common_search_wrapper">
            <DatePicker class="search-ipt" :value="searchIpt.beginDate" format="yyyy-MM-dd" @on-change="getCommonBeginDate" placeholder="请输入开始时间"></DatePicker>
            <DatePicker class="search-ipt" :value="searchIpt.endDate" format="yyyy-MM-dd" @on-change="getCommonEndDate" placeholder="请输入结束时间"></DatePicker>
            <Input class="search-ipt" type="text" v-model="searchIpt.publisher" placeholder="请输入发布者姓名" @on-enter="getTaskList" clearable/>
            <Button type="primary" icon="md-search" class="search_tn" data-level="common" @click="getTaskList">搜索</Button>
            <Button class="top_search_btn" type="primary" ghost icon="ios-funnel" @click="topSearchStatus = true">高级搜索
            </Button>
          </div>
        </div>
      </div>
      <Table class="main_table" size="large" stripe border :columns="tableHeader" :data="tableData">
        <template slot-scope="{ row,index }" slot="writer">
          <div class="jump_color" @click="toUser(row.writer)">{{row.writer}}</div>
        </template>
        <template slot-scope="{ row, index }" slot="schoolName">
          <div class="jump_color" @click="toSchool(row.schoolName)">{{row.schoolName}}</div>
        </template>
        <template slot-scope="{ row, index}" slot="action">
          <div class="jump_color"  @click="checkDetail(row.taskId)">详情</div>
        </template>
      </Table>
    </div>
    <paging :totalNum="totalNum" @pageCallback="getTaskList"></paging>
    <Modal class="top_search_modal" v-model="topSearchStatus" title="高级搜索">
      <div class="top_search_wrapper">
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.subject" placeholder="请输入科目" clearable/>
        <div class="search_time search_item">
          <DatePicker class="time" :value="searchIpt.seniorBeginDate" @on-change="getBeginDate" format="yyyy-MM-dd" placeholder="请输入开始时间"></DatePicker>
          <DatePicker class="time" :value="searchIpt.seniorEndDate" @on-change="getEndDate" format="yyyy-MM-dd" placeholder="请输入结束时间"></DatePicker>
        </div>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.schoolName" placeholder="请输入学校名称" clearable/>
        <Input class="search-ipt search_item" type="text" v-model="searchIpt.classId" placeholder="请输入班级ID" clearable/>
      </div>
      <div class="ctrl-footer" slot="footer">
        <Button class="closed_btn" @click="topSearchStatus = false">取消</Button>
        <Button class="add_record_btn" type="info" icon="md-search" @click="topSearchFn">搜索</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {_getTaskList} from '../api/api';
  import {YearMonthDate} from '../common/common';
  import paging from '../templates/Paging.vue';
  export default {
    name:"Tasks",
    components: {paging},
    data() {
      return {
        pageSize: 10, // 每页条数
        totalNum: 0, // 数据总条数
        searchLevel: 'common',// common普通搜索，senior高级搜索
        topSearchStatus:false, // 高级搜索显示状态,
        tableData:[],
        searchIpt: {
          beginDate: '0',
          endDate:'0',
          publisher: '',
          seniorBeginDate: '',
          seniorEndDate: '',
          seniorPublisher: '',
          classId:'',
          schoolName:'',
          subject: '',
        },
        tableHeader: [
          {
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: '科目',
            key: 'subject'
          },
          {
            title: '发布者',
            key: 'writer',
            slot: 'writer'
          },
          {
            title: '学校',
            key: 'schoolName',
            slot: 'schoolName'
          },
          {
            title: '班级',
            key: 'className',
          },
          {
            title: '发布时间',
            key: 'issueDate',
            sortable:true
          },
          {
            title: '操作',
            key: 'action',
            slot: 'action'
          }

        ],
      }
    },
    methods:{
//      获取作业列表
      getTaskList(msg){
        const self = this;
        let dataInfo = {
          "startDate": self.searchLevel === 'common' ? (self.searchIpt.beginDate?parseInt(self.searchIpt.beginDate.toString().split('-').join('')):0) : (self.searchIpt.seniorBeginDate?parseInt(self.searchIpt.seniorBeginDate.toString().split('-').join('')):0),
          "endDate": self.searchLevel === 'common' ? (self.searchIpt.endDate?parseInt(self.searchIpt.endDate.toString().split('-').join('')):0) : (self.searchIpt.seniorEndDate?parseInt(self.searchIpt.seniorEndDate.toString().split('-').join('')):0),
          "writer": self.searchLevel === 'common' ? (self.searchIpt.publisher) : (self.searchIpt.seniorPublisher),
          "school": self.searchIpt.schoolName,
          "classId": self.searchIpt.classId?parseInt(self.searchIpt.classId):0,
          "subject":self.searchIpt.subject
        };
        let params = {
          page: typeof(msg) === 'object' && msg.pageNum ? msg.pageNum - 1 : 0,
          size: self.pageSize,
          sort: 'createTime,desc'
        };
        _getTaskList(dataInfo,{params:params}).then(res => {
          if(res.code === 0) {
            self.tableData = res.data.content;
            self.totalNum = res.data.total;
            self.tableData.length && self.tableData.forEach(item => {
              item.issueDate = YearMonthDate(item.issueDate);
            })
          }
        })
      },
      //      获取高级搜索的开始时间
      getBeginDate(res) {
        this.searchIpt.seniorBeginDate =res;
      },
//      获取高级搜索的结束时间
      getEndDate(res){
        this.searchIpt.seniorEndDate =res;
      },
      //      获取搜索的开始时间
      getCommonBeginDate(res) {
        this.searchIpt.beginDate =res;
      },
//      获取搜索的结束时间
      getCommonEndDate(res){
        this.searchIpt.endDate =res;
      },
//      高级搜索
      topSearchFn() {
        this.searchLevel = "senior";
        this.getTaskList();
        this.searchIpt = {
          seniorBeginDate:'0',
          seniorEndDate: '0',
          seniorPublisher: '',
          classId:'',
          schoolName:'',
          subject: '',
        };
        this.topSearchStatus = false;
      },
//      跳转到用户列表
      toUser(name) {
        this.$router.push(`/user?name=${name}`);
      },
//      跳转到学校列表
      toSchool(schoolName) {
        this.$router.push(`/schools?id=${schoolName}`)
      },
//      查看详情
      checkDetail(id) {
        this.$router.push(`/tasks/detail?id=${id}`);
      }
    },
    mounted() {
      this.getTaskList();
    },
    created() {
      if(this.$route.query.classId) {
        this.searchIpt.classId = this.$route.query.classId;
      }
    }
  };
</script>
<style>
.ivu-table-column-center {
    font-size: 14px ;
}
</style>



// WEBPACK FOOTER //
// src/components/Tasks.vue